import useIsFeatureEnabled from 'components/hooks/use_is_feature_enabled';
import useIsTeamAssistEnabled from 'components/hooks/use_is_team_assist_enabled';

export default function useIsTeamAssistV2Enabled() {
  const isTeamAssistEnabled = useIsTeamAssistEnabled();
  const isFeatureEnabled = useIsFeatureEnabled();

  return isTeamAssistEnabled && isFeatureEnabled('teamAssistV2');
}
